var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.925,
    height: 100.6,
    viewBox: "0 0 28.925 100.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19989",
    "data-name": "Group 19989",
    transform: "translate(-558.7 -521.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19961",
    "data-name": "Group 19961",
    transform: "translate(559 522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19952",
    "data-name": "Group 19952",
    transform: "translate(17.223 33.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20761",
    "data-name": "Path 20761",
    d: "M321.4,189.636a2.625,2.625,0,0,1-2.624,2.626h0a2.625,2.625,0,0,1-2.624-2.626V185.82a2.625,2.625,0,0,1,2.624-2.625h0a2.625,2.625,0,0,1,2.624,2.625Z",
    transform: "translate(-314.016 -178.367)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19950",
    "data-name": "Group 19950",
    transform: "translate(0 0.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20762",
    "data-name": "Path 20762",
    d: "M316.451,176.445h-.25a3.276,3.276,0,0,0,0,6.552h3.574a3.272,3.272,0,0,0,2.938-4.722h-3.326A3.271,3.271,0,0,1,316.451,176.445Z",
    transform: "translate(-312.926 -176.445)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20763",
    "data-name": "Path 20763",
    d: "M325.118,177.951l-3.863-2.05-5.1,8,3.861,2.05Z",
    transform: "translate(-314.016 -175.901)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19951",
    "data-name": "Group 19951",
    transform: "translate(7.384 4.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20764",
    "data-name": "Path 20764",
    d: "M327.467,184.163a.474.474,0,0,1-.663.081l-.78-.61a.474.474,0,0,1-.081-.665h0a.475.475,0,0,1,.664-.08l.78.61a.475.475,0,0,1,.081.665Z",
    transform: "translate(-324.677 -182.788)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20765",
    "data-name": "Path 20765",
    d: "M326.587,185.288a.475.475,0,0,1-.665.081l-.779-.61a.473.473,0,0,1-.081-.664h0a.473.473,0,0,1,.664-.081l.78.61a.473.473,0,0,1,.081.664Z",
    transform: "translate(-324.379 -183.169)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20766",
    "data-name": "Path 20766",
    d: "M325.706,186.414a.473.473,0,0,1-.663.081l-.78-.61a.471.471,0,0,1-.08-.663h0a.472.472,0,0,1,.663-.081l.779.61a.47.47,0,0,1,.081.664Z",
    transform: "translate(-324.082 -183.55)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19954",
    "data-name": "Group 19954",
    transform: "translate(7.257 15.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19953",
    "data-name": "Group 19953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20767",
    "data-name": "Path 20767",
    d: "M307.24,153.452l.293-4.751a.172.172,0,0,1,.344,0l.293,4.751Z",
    transform: "translate(-301.037 -148.539)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20768",
    "data-name": "Path 20768",
    d: "M302.78,158.688l-4.751-.293a.172.172,0,0,1,0-.343l4.751-.293Z",
    transform: "translate(-297.868 -151.656)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20769",
    "data-name": "Path 20769",
    d: "M310.571,158.688l4.751-.293a.172.172,0,0,0,0-.343l-4.751-.293Z",
    transform: "translate(-302.163 -151.656)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20770",
    "data-name": "Path 20770",
    d: "M309.479,154.322l3.556-3.167a.172.172,0,0,1,.242.242l-3.139,3.579Z",
    transform: "translate(-301.794 -149.409)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20771",
    "data-name": "Path 20771",
    d: "M303.809,155.055l-3.166-3.555a.172.172,0,0,1,.242-.244l3.578,3.139Z",
    transform: "translate(-298.792 -149.443)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20772",
    "data-name": "Path 20772",
    d: "M309.543,163.173a3.273,3.273,0,0,1-3.274,3.274h0A3.273,3.273,0,0,1,303,163.173v-6a3.274,3.274,0,0,1,3.273-3.274h0a3.274,3.274,0,0,1,3.274,3.274Z",
    transform: "translate(-299.602 -150.35)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20773",
    "data-name": "Path 20773",
    d: "M309.543,165.011a3.273,3.273,0,0,1-3.274,3.274h0A3.273,3.273,0,0,1,303,165.011v-6a3.274,3.274,0,0,1,3.273-3.274h0a3.274,3.274,0,0,1,3.274,3.274Z",
    transform: "translate(-299.602 -150.972)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19956",
    "data-name": "Group 19956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20774",
    "data-name": "Path 20774",
    d: "M296.7,153.9c0-.006,0-.014,0-.021a.167.167,0,0,0-.011-.028l-4.111-13.2a1.424,1.424,0,0,0,.152-.637V138.4h-2.848v1.614a1.422,1.422,0,0,0,.481,1.064l3.626,13.552c0,.01,0,.02.006.031s.005.013.008.019l.026.1.013,0a1.355,1.355,0,0,0,.067.131,8.562,8.562,0,0,0,1.359-.369,8.7,8.7,0,0,0,1.267-.547Z",
    transform: "translate(-287.909 -129.413)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19955",
    "data-name": "Group 19955",
    transform: "translate(0.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20775",
    "data-name": "Path 20775",
    d: "M290.722,124.888a1.566,1.566,0,0,0-.388-.066l0,.014a2.165,2.165,0,0,1-1.262,2.6l0,.005a2.063,2.063,0,0,0,.714,4,1.946,1.946,0,0,0,.226-.013l.046,0a3.3,3.3,0,0,0,.657-6.543Z",
    transform: "translate(-287.73 -124.822)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20776",
    "data-name": "Path 20776",
    d: "M292.689,128.738a3.306,3.306,0,0,0-1.826-3.763,1.511,1.511,0,0,0-.355-.151,1.5,1.5,0,0,1,.255.3,3.3,3.3,0,0,1-2.524,5.382,2.08,2.08,0,0,0,.691.661c.06.034.124.065.187.094A3.305,3.305,0,0,0,292.689,128.738Z",
    transform: "translate(-287.902 -124.823)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20777",
    "data-name": "Path 20777",
    d: "M292.667,134.333c0,.534-1.291.968-2.882.968s-2.882-.434-2.882-.968,1.291-.967,2.882-.967S292.667,133.8,292.667,134.333Z",
    transform: "translate(-286.903 -127.711)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20778",
    "data-name": "Path 20778",
    d: "M292.006,135.883c0,.4-.685.715-1.53.715s-1.53-.32-1.53-.715.685-.715,1.53-.715S292.006,135.489,292.006,135.883Z",
    transform: "translate(-287.594 -128.32)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20779",
    "data-name": "Path 20779",
    d: "M290.783,136.289a3.13,3.13,0,0,0-.93.146l.26,6.538a.669.669,0,0,0,1.339,0l.26-6.538A3.123,3.123,0,0,0,290.783,136.289Z",
    transform: "translate(-287.901 -128.699)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20780",
    "data-name": "Path 20780",
    d: "M291.8,144.213a.457.457,0,0,1-.457.457h-1.3a.457.457,0,0,1-.457-.457h0a.457.457,0,0,1,.457-.457h1.3a.457.457,0,0,1,.457.457Z",
    transform: "translate(-287.81 -131.224)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20781",
    "data-name": "Path 20781",
    d: "M290.555,138.027a.473.473,0,0,1-.473.472h-.99a.473.473,0,0,1-.473-.472h0a.474.474,0,0,1,.473-.474h.99a.474.474,0,0,1,.473.474Z",
    transform: "translate(-287.483 -129.127)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20782",
    "data-name": "Path 20782",
    d: "M290.555,139.455a.473.473,0,0,1-.473.472h-.99a.473.473,0,0,1-.473-.472h0a.474.474,0,0,1,.473-.473h.99a.474.474,0,0,1,.473.473Z",
    transform: "translate(-287.483 -129.61)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20783",
    "data-name": "Path 20783",
    d: "M290.555,140.884a.473.473,0,0,1-.473.473h-.99a.473.473,0,0,1-.473-.473h0a.474.474,0,0,1,.473-.474h.99a.474.474,0,0,1,.473.474Z",
    transform: "translate(-287.483 -130.093)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20784",
    "data-name": "Path 20784",
    d: "M293.193,138.136a.473.473,0,0,1-.473.473h-.99a.473.473,0,0,1-.473-.473h0a.472.472,0,0,1,.473-.473h.99a.472.472,0,0,1,.473.473Z",
    transform: "translate(-288.376 -129.164)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20785",
    "data-name": "Path 20785",
    d: "M296.263,204.48a3.559,3.559,0,0,1-2,3.136h17.98s-2.311-1.059-2.311-3.136V170.662a5.211,5.211,0,0,0-5.211-5.211h-3.246c-.164,0-.326.009-.486.023l-.4-1.363c.173-1.257-.075-2.266-.768-2.645l-.514-1.766c-.451-1.55-1.54-1.391-3.089-.94s-2.97,1.021-2.52,2.571l1.2,4.091c-.984,2.193-.973,4.286.1,4.873a1.581,1.581,0,0,0,1.273.042c-.007.107-.017.214-.017.325Z",
    transform: "translate(-289.173 -136.193)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20786",
    "data-name": "Path 20786",
    d: "M298.406,224.048a3.559,3.559,0,0,0,2-3.136V207.044",
    transform: "translate(-290.793 -152.625)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20787",
    "data-name": "Path 20787",
    d: "M300.2,224.048a3.559,3.559,0,0,0,2-3.136V207.044",
    transform: "translate(-291.398 -152.625)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20788",
    "data-name": "Path 20788",
    d: "M314.808,226.621s-2.311-1.059-2.311-3.136v-8.83",
    transform: "translate(-295.557 -155.198)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2026",
    "data-name": "Line 2026",
    y1: 21.32,
    transform: "translate(13.924 50.103)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20789",
    "data-name": "Path 20789",
    d: "M308.667,165.838a1.484,1.484,0,0,1-1.483,1.484h0a1.484,1.484,0,0,1-1.482-1.484v-2.491a1.484,1.484,0,0,1,1.482-1.483h0a1.484,1.484,0,0,1,1.483,1.483Z",
    transform: "translate(-293.26 -137.347)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20790",
    "data-name": "Path 20790",
    d: "M306.893,156.865a2.052,2.052,0,0,1-2.052,2.052V160.4a2.052,2.052,0,1,0,4.1,0v-1.482A2.053,2.053,0,0,1,306.893,156.865Z",
    transform: "translate(-292.969 -135.657)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19957",
    "data-name": "Group 19957",
    transform: "translate(14.197 34.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20791",
    "data-name": "Path 20791",
    d: "M308.356,176.286c-.007.083,0,22.251,0,22.251a3.28,3.28,0,1,0,6.56,0s.007-22.168,0-22.251Z",
    transform: "translate(-308.353 -176.286)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20792",
    "data-name": "Path 20792",
    d: "M307.778,178.057V202.73a5.065,5.065,0,0,1-5.066,5.067h0a5.066,5.066,0,0,1-5.066-5.067V191.039Z",
    transform: "translate(-290.536 -142.823)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19958",
    "data-name": "Group 19958",
    transform: "translate(8.888 36.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20793",
    "data-name": "Path 20793",
    d: "M300.332,202.4a3.28,3.28,0,1,0,6.56,0s.006-22.172,0-22.252",
    transform: "translate(-300.332 -180.151)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19959",
    "data-name": "Group 19959",
    transform: "translate(12.17 41.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20794",
    "data-name": "Path 20794",
    d: "M305.29,206.319a2.351,2.351,0,0,0,1.566-2.215s0-15.877,0-15.935",
    transform: "translate(-305.29 -188.17)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20795",
    "data-name": "Path 20795",
    d: "M305.573,169.033a27.76,27.76,0,0,0-6.531,5.581,19.731,19.731,0,0,0-2.008,2.949c-1.367,2.514-1.627,4.787-.079,6.188a4.713,4.713,0,0,1,.079-2.087,14.582,14.582,0,0,1,2.984-5.371,58.653,58.653,0,0,1,6.66-7.125A5.228,5.228,0,0,0,305.573,169.033Z",
    transform: "translate(-289.944 -139.772)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20796",
    "data-name": "Path 20796",
    d: "M310.405,174.33a5.209,5.209,0,0,0-3.88-5.034c-.019.026-.04.051-.058.079l-9.733,15.084-1.121,1.738a3.752,3.752,0,0,0,.962,5.077l-.962,1.489a3.756,3.756,0,0,0,1.12,5.191h0Z",
    transform: "translate(-289.646 -139.861)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12506",
    "data-name": "Rectangle 12506",
    width: 19.674,
    height: 2.084,
    transform: "translate(3.396 71.423)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19960",
    "data-name": "Group 19960",
    transform: "translate(5.73 25.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20797",
    "data-name": "Path 20797",
    d: "M300.482,163c.265,1.836-1.379,3.594-3.675,3.925a5.04,5.04,0,0,1-1.247.03",
    transform: "translate(-295.56 -163.001)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20798",
    "data-name": "Path 20798",
    d: "M301.954,167.009c.266,1.836-2.02,5.89-4.314,6.223",
    transform: "translate(-296.263 -164.356)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2027",
    "data-name": "Line 2027",
    y1: 21.109,
    x2: 14.052,
    transform: "translate(5.968 31.793)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19963",
    "data-name": "Group 19963",
    transform: "translate(559.888 595.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20799",
    "data-name": "Path 20799",
    d: "M312.714,237.761h-23.68v-.938l.521-.939h22.636l.523.939Z",
    transform: "translate(-288.511 -235.884)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2028",
    "data-name": "Line 2028",
    x2: 23.68,
    transform: "translate(0.522 0.939)",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12507",
    "data-name": "Rectangle 12507",
    width: 24.615,
    height: 24.616,
    transform: "translate(0 1.877)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19962",
    "data-name": "Group 19962",
    transform: "translate(2.568 2.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20800",
    "data-name": "Path 20800",
    d: "M293.232,262.629a.554.554,0,0,1-.554.553h0a.554.554,0,0,1-.553-.553V239.748a.553.553,0,0,1,.553-.553h0a.553.553,0,0,1,.554.553Z",
    transform: "translate(-292.125 -239.195)",
    fill: "#002173",
    stroke: "#002173",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20801",
    "data-name": "Path 20801",
    d: "M298.783,262.629a.554.554,0,0,1-.553.553h0a.554.554,0,0,1-.553-.553V239.748a.553.553,0,0,1,.553-.553h0a.553.553,0,0,1,.553.553Z",
    transform: "translate(-294.002 -239.195)",
    fill: "#002173",
    stroke: "#002173",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20802",
    "data-name": "Path 20802",
    d: "M304.335,262.629a.554.554,0,0,1-.553.553h0a.554.554,0,0,1-.553-.553V239.748a.553.553,0,0,1,.553-.553h0a.553.553,0,0,1,.553.553Z",
    transform: "translate(-295.88 -239.195)",
    fill: "#002173",
    stroke: "#002173",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20803",
    "data-name": "Path 20803",
    d: "M309.887,262.629a.554.554,0,0,1-.553.553h0a.554.554,0,0,1-.553-.553V239.748a.553.553,0,0,1,.553-.553h0a.553.553,0,0,1,.553.553Z",
    transform: "translate(-297.757 -239.195)",
    fill: "#002173",
    stroke: "#002173",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20804",
    "data-name": "Path 20804",
    d: "M315.438,262.629a.553.553,0,0,1-.553.553h0a.554.554,0,0,1-.553-.553V239.748a.553.553,0,0,1,.553-.553h0a.552.552,0,0,1,.553.553Z",
    transform: "translate(-299.634 -239.195)",
    fill: "#002173",
    stroke: "#002173",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20805",
    "data-name": "Path 20805",
    d: "M320.991,262.629a.554.554,0,0,1-.554.553h0a.554.554,0,0,1-.553-.553V239.748a.553.553,0,0,1,.553-.553h0a.553.553,0,0,1,.554.553Z",
    transform: "translate(-301.512 -239.195)",
    fill: "#002173",
    stroke: "#002173",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaIcon);
export default __webpack_public_path__ + "static/media/usa_icon.df7c7b995e76636bf35840b95752af7e.svg";
export { ForwardRef as ReactComponent };